import store from "@/store/store"
import { computed, ComputedRef } from 'vue'
import { ModuleNamespaces } from "@/store/types/storeGlobalTypes"
import { LegalSearchDataType, LegalSearchTabType } from '@/store/modules/legalSearch/legalSearchTypes'


interface ResponseUseLegalSearch {
  sessionId: ComputedRef<string>,
  searchTabs: ComputedRef<LegalSearchTabType>,
  searchData: ComputedRef<LegalSearchDataType>,
  loadSessionId: (encryptedUserId: string) => Promise<void>
  loadSearchTabs: (term: string, sessionId: string) => Promise<void>
  loadSearchData: (term: string, sessionId: string, index: string, numPage: number, numRecs: number) => Promise<void>
}


export default function useLegalSearch(): ResponseUseLegalSearch {
  const sessionId = computed(() => store.getters[`${ModuleNamespaces.LEGAL_SEARCH}/getSessionId`])
  const searchTabs = computed(() => store.getters[`${ModuleNamespaces.LEGAL_SEARCH}/getSearchTabs`])
  const searchData = computed(() => store.getters[`${ModuleNamespaces.LEGAL_SEARCH}/getSearchData`])

  const loadSessionId = async (encryptedUserId: string) => {
    console.log('loadSessionId', encryptedUserId)
    await store.dispatch(`${ModuleNamespaces.LEGAL_SEARCH}/fetchSessionId`, encryptedUserId)
  }
  const loadSearchTabs = async (term: string, sessionId: string) => {
    console.log('loadSearchTabs', term, sessionId)
    await store.dispatch(`${ModuleNamespaces.LEGAL_SEARCH}/fetchSearchTabs`, { term, sessionId })
  }
  const loadSearchData = async (term: string, sessionId: string, index: string, numPage: number, numRecs: number) => {
    console.log('loadSearchData', term, sessionId, index, numPage, numRecs)
    await store.dispatch(`${ModuleNamespaces.LEGAL_SEARCH}/fetchSearchData`, { term, sessionId, index, numPage, numRecs })
  }


  return {
    sessionId,
    searchTabs,
    searchData,
    loadSessionId,
    loadSearchTabs,
    loadSearchData
  }
}
